const prefix = "/webabsamdinpanelpage"
export const AUTH_PAGE = prefix+"/auth"
export const USERS_PAGE =  prefix+"/users"
export const OPERATIONS_PAGE = prefix+ "/operations"
export const MESSAGE_PAGE = prefix+'/messages'